interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Bitcoin = ({ ...props }: IconProps) => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_24445_137942)">
      <rect
        y="0.452148"
        width="32"
        height="32"
        rx="16"
        fill="#E9A71F"
      />
      <circle
        cx="16"
        cy="16.4521"
        r="16"
        fill="#E9A71F"
      />
      <path
        d="M20.9051 15.8769C20.9051 15.8769 20.9027 15.8721 20.9051 15.8696C21.4827 15.2363 21.8418 14.4112 21.8685 13.5182C21.9268 11.5574 20.3688 9.84174 18.3522 9.72283H17.4447C17.4447 9.72283 17.4398 9.72283 17.4398 9.71798V6.8569C17.4398 6.8569 17.4398 6.85205 17.435 6.85205H15.6829C15.6829 6.85205 15.678 6.85205 15.678 6.8569V9.71798C15.678 9.71798 15.678 9.72283 15.6732 9.72283H14.2414C14.2414 9.72283 14.2366 9.72283 14.2366 9.71798V6.8569C14.2366 6.8569 14.2366 6.85205 14.2317 6.85205H12.4796C12.4796 6.85205 12.4748 6.85205 12.4748 6.8569V9.71798C12.4748 9.71798 12.4748 9.72283 12.4699 9.72283H8.96579C8.96579 9.72283 8.96094 9.72283 8.96094 9.72768V11.8074C8.96094 11.8074 8.96094 11.8122 8.96579 11.8122H10.6766C10.9654 11.8122 11.2008 12.0476 11.2008 12.3364V15.2217C11.2008 15.2217 11.2008 15.2266 11.1959 15.2266V17.0927C11.1959 17.0927 11.2008 17.0927 11.2008 17.0976V20.4634C11.2008 20.7522 10.9654 20.9875 10.6766 20.9875H9.33708C9.33708 20.9875 9.33222 20.9875 9.33222 20.99L8.97792 23.1667C8.97792 23.1667 8.97792 23.1716 8.98278 23.1716H12.4772C12.4772 23.1716 12.4821 23.1716 12.4821 23.1764V26.0472C12.4821 26.0472 12.4821 26.0521 12.4869 26.0521H14.239C14.239 26.0521 14.2439 26.0521 14.2439 26.0472V23.1764C14.2439 23.1764 14.2439 23.1716 14.2487 23.1716H15.6805C15.6805 23.1716 15.6853 23.1716 15.6853 23.1764V26.0472C15.6853 26.0472 15.6853 26.0521 15.6902 26.0521H17.4422C17.4422 26.0521 17.4471 26.0521 17.4471 26.0472V23.1716H18.3571C20.8348 23.3414 22.8683 21.3079 22.7785 19.0389C22.7276 17.7455 21.9947 16.5734 20.91 15.8769H20.9051ZM14.2414 11.8171C14.2414 11.8171 14.2414 11.8122 14.2463 11.8122H16.5613C17.532 11.7685 18.3522 12.5548 18.3522 13.5182C18.3522 14.4816 17.532 15.2678 16.5613 15.2241H14.2463C14.2463 15.2241 14.2414 15.2241 14.2414 15.2193V11.8146V11.8171ZM17.4422 20.9851H14.2463C14.2463 20.9851 14.2414 20.9851 14.2414 20.9803V17.0951C14.2414 17.0951 14.2414 17.0903 14.2463 17.0903H17.4422C18.4372 17.1898 19.204 18.0367 19.204 19.0365C19.204 20.0363 18.4372 20.8832 17.4422 20.9827V20.9851Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_24445_137942">
        <rect
          y="0.452148"
          width="32"
          height="32"
          rx="16"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
